import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BaseLocalRepository } from '@data/base/base-local.repository';
import { CidadeEntity } from '@domain/dto/cidade/cidade-get.dto';
import { map, mergeMap, Observable } from 'rxjs';
import { ApiResources } from '@constants/api-resources';
import { HomeMapper } from './home.mapper';

@Injectable()
export class HomeRepository extends BaseLocalRepository {
  private mapper = new HomeMapper();
  constructor(httpClient: HttpClient) {
    super(httpClient, ApiResources.CITIES);
  }
  get(): Observable<CidadeEntity> {
    return this.getRequest<CidadeEntity>()
    .pipe(mergeMap((item) => item.Data))
    .pipe(map(this.mapper.fromJson));
  }
}
